function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export const CodeTextIcon = ({
  size,
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size ?? "32px",
    height: size ?? "32px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, svgProps), /*#__PURE__*/React.createElement("path", {
    d: "M18.3072 5.62939L13.6924 26.3701",
    stroke: color ?? "#667085",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7778 10.8149L28.963 16.0001L23.7778 21.1853",
    stroke: color ?? "#667085",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22181 21.1853L3.03662 16.0001L8.22181 10.8149",
    stroke: color ?? "#667085",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
//# sourceMappingURL=CodeTextIcon.js.map